import { showsDraftLabel, type ContentStatus } from '@grc/shared/vocabulary';

const env = import.meta.env;

export const config = {
  tenantId: env.VITE_ENTRA_TENANT_ID as string | undefined,
  clientId: env.VITE_ENTRA_CLIENT_ID as string | undefined,
  /** API origin: the environment's Front Door endpoint, e.g. https://fde-grc-dev-xxxx.z01.azurefd.net. Empty = same origin. */
  apiBase: (env.VITE_API_BASE_URL as string | undefined) ?? '',
  environment: (env.VITE_GRC_ENVIRONMENT as string | undefined) ?? 'local',
};

export const apiScope = () => `api://${config.clientId}/access_as_user`;

/**
 * Whether to show a "draft for National IT review" label for National content with this status. Production
 * never does; dev, staging and test show the real status. Use this instead of comparing *_STATUS directly.
 */
export const showDraftLabel = (status: ContentStatus) => showsDraftLabel(status, config.environment);
